export default function repeatableBookings() {
    return {
        restrict: "E",
        scope: {
            booking: "=",
            //isCollapsed : '='
        },
        template: require("./template.html"),

        controller: function (
            $scope,
            $rootScope,
            $q,

            repeatableBookingFactory,
            repeatableResultsFactory
        ) {
            // Set collapse onload state
            $scope.booking.isCollapsed = true;

            $scope.modifiedSearchOptions = false;

            $scope.progressCount = null;
            $scope.HttpRequestCount = null;

            var RepeatableProgressAddEventListener = $rootScope.$on(
                "repeatable-progress-count-add",
                function () {
                    //avail params : event, obj
                    $scope.progressCount++;
                }
            );

            $scope.$on("destroy", RepeatableProgressAddEventListener);

            var RepeatableProgressDoneEventListener = $rootScope.$on(
                "repeatable-progress-done",
                function () {
                    //avail params : event, obj
                    // reset progress vars
                    $scope.progressCount = null;
                    $scope.HttpRequestCount = null;
                }
            );

            $scope.$on("destroy", RepeatableProgressDoneEventListener);

            $scope.toogleCollapsible = function (bool) {
                $scope.booking.isCollapsed = bool;

                $rootScope.$broadcast("any-repeabable-collapsed", {
                    collapsed: bool,
                });
            };

            /**
             * REPEATABLE BOOKINGS
             *
             * utilizes the request bookings factory
             *
             * 1. find ocurring date objects on weekdays in a timerange for each booking in the basket
             * 2. request API for availability on each date
             */

            $scope.weekRanges = angular.copy(
                repeatableBookingFactory.weekRanges
            );

            //Crete a scoped instance of weekdays
            $scope.weekdays = angular.copy(repeatableBookingFactory.weekdays);

            //Pre selected options
            $scope.selectedWeekDays = [
                repeatableBookingFactory.setSameAsBookingOriginWeekday(
                    $scope.booking,
                    $scope.weekdays
                ),
            ];

            $scope.selectedWeekRange = null; //repeatableBookingFactory.weekRanges[0]; // from parent booking

            /**
             * add weekRange to array of selectWeekRange
             * @param  {obj}  oWeekRange
             *
             * $scope requirements:
             *     booking,
             *     selectedWeekRange,
             *     selectedWeekDays
             */
            $scope.selectWeekRange = function (oWeekRange) {
                $scope.modifiedSearchOptions = true;

                $scope.selectedWeekRange = oWeekRange;
            };

            /**
             * add weeekday to array of weekdays
             * @param  {obj}  oWeekDay
             *
             * $scope requirements:
             *     selectedWeekRange,
             *     selectedWeekDays
             */
            $scope.selectWeekDay = function (oWeekDay) {
                // Toggle
                oWeekDay.active = !oWeekDay.active;

                $scope.modifiedSearchOptions = true;

                // remove from array of selectedWeekDays
                if (!oWeekDay.active) {
                    $scope.selectedWeekDays.splice(
                        $scope.selectedWeekDays.indexOf(oWeekDay),
                        1
                    );
                }

                if (oWeekDay.active) {
                    // add to array of selectedWeekDays
                    $scope.selectedWeekDays.push(oWeekDay);
                }
            };

            $scope.searchRepeatables = function () {
                $scope.modifiedSearchOptions = false;

                // prepareRepeatableSearchObject
                var aRepeatables =
                    repeatableBookingFactory.prepareRepeatableSearchObject(
                        $scope.selectedWeekRange,
                        $scope.selectedWeekDays,
                        $scope.booking
                    );

                // prepareScopeThenRequestAPI
                $scope.prepareScopeThenRequestAPI(aRepeatables);
            };

            $scope.prepareScopeThenRequestAPI = function (aRepeatables) {
                $scope.progressCount = 0;
                $scope.HttpRequestCount =
                    repeatableResultsFactory.getHttpRequestCount(aRepeatables);
                $scope.apiResultCollection = $scope.requestAPIForAvailability(
                    aRepeatables,
                    $scope.booking
                );
            };

            /**
             * Request the API for availability
             * @param  [array] aRepeatables - contains all dates of user selected occurring weekdays
             *
             * $scope requirements:
             *     booking
             *
             * @return {[array]}
             */
            $scope.requestAPIForAvailability = function (
                aRepeatables,
                booking
            ) {
                // $q
                // Since the API is called for each booking,
                // we need to be sure all api calls is completed,
                // before executing the following code

                // Chain the promises
                var promises = [];

                angular.forEach(aRepeatables, function (weekly) {
                    angular.forEach(
                        weekly.futureWeekdaysInRange,
                        function (weekday) {
                            //store each request in promises array
                            var apiRequest =
                                repeatableResultsFactory.asyncPromiseFunc(
                                    weekday,
                                    booking
                                );
                            promises.push(apiRequest);
                        }
                    );
                });

                $q.all(promises).then(
                    function (result) {
                        repeatableResultsFactory.clearProgressCounter();

                        // Process API results in factory
                        $scope.apiResultCollection =
                            repeatableResultsFactory.processRawApiResults(
                                result,
                                booking
                            );

                        //console.log($scope.apiResultCollection);

                        // Send the repeatable-result.js
                        //$rootScope.$broadcast( 'repeatable-api-promises-fullfilled', {'apiCollection' : apiResultCollection});
                    },
                    function (reason) {
                        //console.log('------Promises error----------');
                        console.error(reason);

                        repeatableResultsFactory.clearProgressCounter();
                    }
                );
            };
        },
    };
}
